export default function CsharpVariables() {
  return (
    <h2>Csharp Variables</h2>
  );
}
